import React from 'react';
import { withStyles } from 'material-ui/styles';
import classnames from 'classnames';
import { func, string, shape } from 'prop-types';
import Grid from 'material-ui/Grid';
import PrintIcon from 'material-ui-icons/Print';
import ExitIcon from 'material-ui-icons/ExitToApp';
import AttachMoneyIcon from 'material-ui-icons/AttachMoney'
import Typography from 'material-ui/Typography';

import Button from '../../common/Button';

const styles = () => ({
  '@media print': {
    root: {
      display: 'none'
    }
  }
})

export const Actions = ({
  onCancel,
  onPrint,
  onRequestQuote,
  className,
  classes
}) => (
  <Grid container className={classnames(className, classes.root)}>
    <Grid container justify="center">
      <Grid item>
        <Typography variant="caption">
          For Optimal result, please print in landsacpe mode
        </Typography>
      </Grid>
    </Grid>
    <Grid container justify="center">
      <Grid item>
        <Button
          default
          type="button"
          variant="raised"
          onClick={onCancel}
        >
          <ExitIcon />
          &nbsp; Exit
        </Button>
        <Button
          primary
          type="button"
          variant="raised"
          onClick={onPrint}
        >
          <PrintIcon />
          &nbsp; Print
        </Button>
        <Button
          primary
          type="button"
          variant="raised"
          onClick={onRequestQuote}
        >
          <AttachMoneyIcon />
          &nbsp; Quote 
        </Button>
      </Grid>
    </Grid>
  </Grid>
);

Actions.propTypes = {
  onCancel: func.isRequired,
  onPrint: func.isRequired,
  onRequestQuote: func.isRequired,
  classes: shape({ root: string }).isRequired,
  className: string
}

Actions.defaultProps = {
  className: undefined
}

export default withStyles(styles)(Actions);





// WEBPACK FOOTER //
// ./src/components/StackupDesign/Report/Actions.jsx